import React from 'react';
import PropTypes from 'prop-types';

class ContactsBlock extends React.PureComponent {
  render() {
    const { tt: { contacts } } = this.props;
    return (
      <div className="block contacts" id="contact">
        <div className="container">
          <div className="title">
            {contacts.title}
          </div>
          <div className="row">
            <div className="col m6">
              <div className="subject">{contacts.onlineShop.title}</div>
              <div className="info">
                <div className="field">{contacts.onlineShop.hongKong}</div>
                <div className="content">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shop-now"
                    href="https://mrrichbakery.myshopify.com/"
                  >
                    Shop Now
                  </a>
                </div>
                <div className="field">{contacts.onlineShop.china}</div>
                <div className="content">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shop-now"
                    href="http://mrrich.jd.hk/"
                  >Shop Now</a></div>
              </div>
            </div>
            <div className="col m6">
              <div className="subject">{contacts.enquiry.title}</div>
              <div className="info">
                <div className="field">{contacts.enquiry.tel}</div>
                <div className="content">+852 9659 7700</div>
              </div>
              <div className="info">
                <div className="field">{contacts.enquiry.line}</div>
                <div className="content">littlerabbit99</div>
              </div>
              <div className="info">
                <div className="field">{contacts.enquiry.email}</div>
                <div className="content">mrrich@mrrichbakery.com</div>
              </div>
            </div>
          </div>
          <ul className="address-block">
            {contacts.area.map((area, i) => (
              <li key={area.shopName}>
                <div>
                  <a href={area.link} target="_blank">
                    <div
                      className="map"
                      style={{
                        backgroundImage: `url(${area.map})`
                      }}
                    />
                  </a>
                  <ul>
                    <li className="shop-name subject">{contacts.area[i].shopName}</li>
                    <li className="address">{contacts.area[i].address}</li>
                    {contacts.area[i].tel &&
                      <li className="tel">Tel:{contacts.area[i].tel}</li>
                    }
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

ContactsBlock.propTypes = {
  tt: PropTypes.object,
};

ContactsBlock.defaultProps = {
  tt: {},
};

export default ContactsBlock;



// WEBPACK FOOTER //
// ./src/blocks/ContactsBlock/index.js